export default "__VITE_ASSET__B3nb0rc6__"